export default (t) => ({
  element: 'bpmn:StartEvent',
  service: '',
  title: t('script.controlls.startEvent.title'),
  helplink: '',
  class: 'event',
  group: 'event',
  color: '#869d49',
  border: 2,
  icon: 'anticon-icon arrows-triangle-big-4-01',
  offset_x: 14,
  offset_y: -15,
  toolbar_offset_y: -10,
  toolbar_offset_x: 20,
  icon_scale: 1.1,
  priority: 0,
  config: [
    {
      id: 'commonSection',
      name: t('script.common.general'),
      type: 'group',
    },
    {
      id: 'name',
      name: t('script.common.description'),
      type: 'text',
      readOnly: false,
      config: {
        defaultEmptyValue: t('script.controlls.startEvent.title'),
        type: 'text',
        valueType: 'const',
        map: 'input',
      },
    },
    {
      id: 'description',
      name: t('script.common.description'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        valueType: 'const',
        map: 'input',
      },
    },
  ],
  exits: [],
});
